<template>
  <div id="app">
    <!--主体部分-->
    <transition :name="viewTransition" :css="!!direction">
      <keep :include="includeList" :refresh="refresh">
        <router-view ref="routeBox" :key="$route.fullPath"></router-view>
      </keep>
    </transition>
    <!--底部导航-->

    <!--数据加载动画-->
    <t-loading v-if="isLoading"></t-loading>
  </div>
</template>
<script>
  import {mapState} from 'vuex';

  export default {
    name: 'app',
    data() {
      return {};
    },
    computed: {
      ...mapState({
        isLoading: state => state.vm.isLoading,
        route: state => state.vm.routeData,
        direction: state => state.vm.direction,
        includeList: state => state.vm.includeList,
        refresh: state => state.vm.refresh,
      }),
      // 内容切换动画
      viewTransition() {
        if (!this.direction) return ' ';
        return `pop-${this.direction === 'in' ? 'in' : 'out'}`;
      },
    },
    //App.vue
    mounted() {
      if (this._isMobile()) {
        this.jumpUrl();
      }
    },

    methods: {
      //App.vue，判断是否为移动端
      _isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag;
      },
      jumpUrl: async function() {
          let url = window.location.pathname + window.location.search;
          let res = await this.$getJSON('nav/changeUrl',{url:url});
          if (res.code == 1) {
              let wapDomain = res.data.wapDomain;
              let wapUrl = res.data.wapUrl;
              window.location.href = wapDomain +"/#"+ wapUrl;
          }
      }
    },
  };

</script>
<style lang="scss">
  @import 'style/iconfont.css';
  @import 'style/icon.css';
  @import 'style/base.css';
  @import 'swiper/dist/css/swiper.css';
  @import 'style/transition.css';

  .pop-out-enter-active,
  .pop-out-leave-active,
  .pop-in-enter-active,
  .pop-in-leave-active {
    position: absolute;
    width: 100%;
    top: 0;
    bottom: 0;
    transition: all 500ms;
    backface-visibility: hidden;
    perspective: 1000px;
  }

  .pop-out-enter {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }

  .pop-out-leave-active {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }

  .pop-in-enter {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }

  .pop-in-leave-active {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }

</style>



// WEBPACK FOOTER //
// src/App.vue